var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStratNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 577.97 519.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #146f9b;\n        opacity: .3;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        stroke-dasharray: 11.02 11.02;\n      }\n\n      .cls-5, .cls-6 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .92px;\n      }\n\n      .cls-3 {\n        font-family: Poppins-MediumItalic, Poppins;\n        font-size: 38.5px;\n        font-style: italic;\n        font-weight: 500;\n      }\n\n      .cls-7 {\n        opacity: .8;\n      }\n\n      .cls-4 {\n        opacity: .34;\n      }\n      .cls-8{\n         fill: #146f9b;\n        opacity: .3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 298.23,
    cy: 202.99,
    r: 159.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 246.69,
    cy: 316.31,
    r: 159.41
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.44,199.11l-42.49,46.37c39.23,35.94,41.89,96.88,5.94,136.11-35.94,39.23-96.88,41.89-136.11,5.94l-42.49,46.37c64.83,59.41,165.55,55.01,224.96-9.82,59.41-64.83,55.01-165.55-9.82-224.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.47,320.2l42.49-46.37c-39.23-35.94-41.89-96.88-5.94-136.11,35.94-39.23,96.88-41.89,136.11-5.94l42.49-46.37c-64.83-59.41-165.55-55.01-224.96,9.82-59.41,64.83-55.01,165.55,9.82,224.96Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(0 337.42) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Design")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(414.04 228.48) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Strategy"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 298.23,
    y1: 202.99,
    x2: 294.34,
    y2: 199.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 286.54,
    y1: 191.31,
    x2: 103.34,
    y2: 8.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 99.44,
    y1: 4.21,
    x2: 95.56,
    y2: 0.32
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 449.36,
    y1: 518.98,
    x2: 445.47,
    y2: 515.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 437.67,
    y1: 507.3,
    x2: 254.47,
    y2: 324.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 250.58,
    y1: 320.2,
    x2: 246.69,
    y2: 316.31
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratNew);
export default __webpack_public_path__ + "static/media/stratNew.268a4ef73e93819434e03d5ca51678f2.svg";
export { ForwardRef as ReactComponent };